import React from "react";
import PropTypes from "prop-types";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import classNames from "classnames";

import { formatDate, parseDate } from "react-day-picker/moment";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core";

function DayPickerTextField(props) {
  const { value, placeholder, label, ...restProps } = props;

  return (
    <TextField
      {...restProps}
      value={value || ""}
      label={label || ""}
      inputProps={{ "aria-label": placeholder || "", placeholder: "" }}
    />
  );
}

function DatePicker(props) {
  const { className, classes, value, onChange, ...restProps } = props;

  return (
    <div
      className={classNames(className, classes.root)}
      onClick={(e) => e.preventDefault()}
    >
      <DayPickerInput
        value={value}
        formatDate={formatDate}
        parseDate={parseDate}
        placeholder={""}
        component={DayPickerTextField}
        onDayChange={onChange}
        inputProps={restProps}
      />
    </div>
  );
}

DatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

const styles = (theme) => ({
  root: {
    display: "inline-block",
    "& .DayPicker-Day": {
      borderRadius: 0,
    },
    "& .DayPicker-Day--start": {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%",
    },
    "& .DayPicker-Day--end": {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
    },
    "& .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside)":
      {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
  },
});

export default withStyles(styles)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/Forms/DatePicker.jsx